import { render, staticRenderFns } from "./AgentPaFinalization.vue?vue&type=template&id=55664e0f"
import script from "./AgentPaFinalization.vue?vue&type=script&lang=js"
export * from "./AgentPaFinalization.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports